export enum DRAWER_POSITION {
    LC = "LC",
    RC = "RC",
}
